import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of, switchMap, take } from 'rxjs';
import { UserManager } from '../../../../managers/user.manager';
import { User } from '../../../../models/ui/user.model';

@Component({
    selector: 'lex-export-users-dialog',
    templateUrl: './export-users-dialog.component.html',
    styleUrls: ['./export-users-dialog.component.scss'],
    standalone: false
})
export class ExportUsersDialogComponent {

	public selectedUser: User = null;
	public exportUserForm: UntypedFormGroup;

	constructor(
		private userManager: UserManager,
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<ExportUsersDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private inputUser: User) {
		this.selectedUser = inputUser;
		this.exportUserForm = this.formBuilder.group({
			exportAll: ['all', [Validators.required]]
		});
	}

	public export(): void {
		const exportOption = this.exportUserForm.controls['exportAll'].value;
		let exportOperation: Observable<any> = of(null);
		if (exportOption === 'all' || exportOption === 'filter') {
			exportOperation = this.userManager.userCollection$.pipe(
				take(1),
				switchMap((data) => this.userManager.exportUsers(data.map(x => x.id)))
			);
		} else if (exportOption === 'one') {
			exportOperation = this.userManager.exportUsers([this.inputUser.id])
		}
		exportOperation.subscribe(() =>	this.dialogRef.close());
	}
}
